<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Kickousel } from '#library/components.schema.build.ts'
	import Sidekick from '#blocks/sidekick.svelte'
	import emblaCarouselSvelte from 'embla-carousel-svelte'
	import type { EmblaCarouselType } from 'embla-carousel'
	import Pagination from '#components/pagination.svelte'

	interface Props {
		blok: Blok<Kickousel>
	}

	let { blok }: Props = $props()
	let active = $state(0)
	let embla_api: EmblaCarouselType | undefined = $state()

	function onInit(event: CustomEvent) {
		embla_api = event.detail
		if (!embla_api) return

		embla_api.on('select', () => {
			active = embla_api?.selectedScrollSnap() ?? 0
		})
	}

	const items = $derived(blok.items ?? [])
</script>

<section class="kickousel {blok.theme}" {...attrs(blok)}>
	{#if blok.title?.text}
		<svelte:element this={blok.title?.tag || 'div'} class="title">
			{blok.title?.text}
		</svelte:element>
	{/if}
	<div class="viewport" use:emblaCarouselSvelte onemblaInit={onInit}>
		<div class="items">
			{#each items as item (item._uid)}
				<Sidekick
					blok={{ ...item, theme: blok.theme, padding_top: '0', padding_bottom: '0', titlealt: true }}
					div
					pagpad
				/>
			{/each}
		</div>
	</div>
	<div class="pagi contain">
		<Pagination
			onprev={embla_api?.scrollPrev}
			onnext={embla_api?.scrollNext}
			onpage={embla_api?.scrollTo}
			items={blok.items?.length}
			{active}
			alt
		/>
	</div>
</section>

<style lang="css">
	.kickousel {
		background-color: var(--c-background);
		color: var(--c-foreground);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.items {
		align-items: start;
		display: flex;

		@media (--from-mobile) {
			align-items: center;
		}

		:global {
			.sidekick {
				flex: 1 0 100%;
			}
		}
	}

	.title {
		font: 600 var(--f-h2);
		letter-spacing: var(--ls-h2);
		margin-block-end: var(--s-80);
		text-align: center;
	}

	.pagi {
		margin-block-start: 1rem;

		@media (--from-tablet) {
			margin-block-start: -2.375rem;

			:global(.pagination) {
				left: calc(50% + 0.875rem);
				width: 50%;
			}
		}
	}
</style>
